import dayjs from "dayjs";

const mockItems = () => [
  {
    productListId: 101,
    catalogListId: 201,
    label: "Prodotto demo Alfa",
    clickCount: 120,
    imageUrls: ["https://placehold.co/120x120/png?text=A"],
  },
  {
    productListId: 102,
    catalogListId: 202,
    label: "Prodotto demo Beta",
    clickCount: 95,
    imageUrls: [],
  },
  {
    productListId: 103,
    catalogListId: 203,
    label: "Prodotto demo Gamma",
    clickCount: 64,
    imageUrls: ["https://placehold.co/120x120/png?text=G"],
  },
];

function withGrowthPercents(points) {
  let prev = null;
  return points.map((p) => {
    const cnt = Number(p.clickCount) || 0;
    let growthPercent = null;
    if (prev != null) {
      if (prev === 0) {
        growthPercent = cnt > 0 ? 100 : 0;
      } else {
        growthPercent = ((cnt - prev) * 100) / prev;
      }
    }
    prev = cnt;
    return { ...p, growthPercent };
  });
}

function mockTrafficMonthsRolling(limit) {
  const points = [];
  const base = dayjs().startOf("month");
  for (let i = 0; i < limit; i += 1) {
    const d = base.subtract(limit - 1 - i, "month");
    points.push({ period: d.format("YYYY-MM"), clickCount: 8 + (i % 6), growthPercent: null });
  }
  return withGrowthPercents(points);
}

function mockTrafficDaysRolling(limit) {
  const points = [];
  const base = dayjs().startOf("day");
  for (let i = 0; i < limit; i += 1) {
    const d = base.subtract(limit - 1 - i, "day");
    points.push({ period: d.format("YYYY-MM-DD"), clickCount: 6 + (i % 4), growthPercent: null });
  }
  return withGrowthPercents(points);
}

function buildMockTrafficPointsForRange(startStr, endStr, resolution) {
  const start = dayjs(startStr).startOf("day");
  const end = dayjs(endStr).startOf("day");
  const points = [];
  if (resolution === "month") {
    let d = start.startOf("month");
    const endM = end.endOf("month");
    let i = 0;
    while (!d.isAfter(endM, "month")) {
      points.push({ period: d.format("YYYY-MM"), clickCount: 8 + (i % 6), growthPercent: null });
      d = d.add(1, "month");
      i += 1;
    }
  } else {
    let d = start;
    let i = 0;
    while (!d.isAfter(end, "day")) {
      points.push({ period: d.format("YYYY-MM-DD"), clickCount: 6 + (i % 4), growthPercent: null });
      d = d.add(1, "day");
      i += 1;
    }
  }
  return withGrowthPercents(points);
}

const mockCategories = () => [
  { categoryListId: 1, label: "Elettronica", clickCount: 42 },
  { categoryListId: 2, label: "Casa", clickCount: 31 },
  { categoryListId: 3, label: "Sport", clickCount: 18 },
];

export const mockVendorStatsProvider = {
  getTopProductsByClick: async (_request) => ({
    statusCode: 202,
    message: "Mock top products by click",
    items: mockItems(),
  }),

  getVendorTraffic: async (request) => {
    const resolution = request?.resolution === "month" ? "month" : "day";
    const hasRange = Boolean(request?.startDate && request?.endDate);
    if (!hasRange) {
      const raw = Number(request?.limit);
      const limit = Number.isFinite(raw) ? Math.min(120, Math.max(1, raw)) : 10;
      const points = resolution === "month" ? mockTrafficMonthsRolling(limit) : mockTrafficDaysRolling(limit);
      return {
        statusCode: 202,
        message: "Mock traffic",
        resolution,
        points,
      };
    }
    return {
      statusCode: 202,
      message: "Mock traffic",
      resolution,
      points: buildMockTrafficPointsForRange(request.startDate, request.endDate, resolution),
    };
  },

  getTopCategoriesByClick: async (_request) => ({
    statusCode: 202,
    message: "Mock categories",
    items: mockCategories(),
  }),
};
